/**
 * SocialMediaService
 * Service for SocialMedia entity operations
 * Route: api/social-media
 * Controller: SocialMediaController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * SocialMediaService
 * Handles social media platform CRUD operations
 * Maps to /api/social-media endpoint
 */
export class SocialMediaService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SocialMediaService.DEFAULT_SERVICE_PATH,
            basePath: SocialMediaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
SocialMediaService.DEFAULT_SERVICE_PATH = 'locations';
SocialMediaService.BASE_PATH = 'api/social-media';
//# sourceMappingURL=SocialMediaService.js.map